<template>
  <div class="top">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'SummaryTop',

  computed: {},
}
</script>

<style lang="scss" scoped>
.top {
  position: absolute;
  top: 112px;
  left: 0;
  height: 119px;
  // background-image: url('/images/left-bottom.svg');
  padding-left: 50%;
  color: #1c5eaa;
  // padding-top: 30px;
}
</style>
